import React from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom"; // <-- Step 1
import "./ServiceSection.css";

const services = [
  { title: "Social Media Management", img: "https://static.wixstatic.com/media/d56fdc_fa4d57035414423a827160224fd966a2~mv2.png/v1/fill/w_749,h_481,al_c,q_90,usm_0.66_1.00_0.01,enc_avif,quality_auto/White%20and%20Blue%20Illustrative%20Business%20Social%20Media%20Marketing%20Facebook%20Post.png" },
  { title: "Performance Marketing", img: "https://static.wixstatic.com/media/d56fdc_467669d98fd244cab0731bd7c30e9e81~mv2.png/v1/fill/w_705,h_436,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/Orange%20and%20Brown%20Illustration%20Business%20Report%20Presentation%20(12).png" },
  { title: "Search Engine Optimazation", img: "https://static.wixstatic.com/media/d56fdc_399c17a48fe64163a9d490806b06d87a~mv2.png/v1/fill/w_715,h_443,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/Blue%20and%20White%20Illustrative%20Digital%20Marketing%20Instragram%20Post.png" },
  { title: "Email & Whatsapp Marketing", img: "https://static.wixstatic.com/media/d56fdc_c71a3a78272b4bca9e60529f32faad3d~mv2.png/v1/fill/w_715,h_443,fp_0.49_0.40,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/Purple%20White%20Simple%20Modern%20Web%20Development%20Instagram%20Post%20(1).png" },
  { title: "Repuatation & Trust Building", img: "https://static.wixstatic.com/media/d56fdc_83be921563b045dc87b9981e88643cd1~mv2.png/v1/crop/x_310,y_119,w_1301,h_841/fill/w_683,h_524,fp_0.50_0.50,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/Blue%20and%20White%20Illustration%20Build%20a%20Business%20Team%20Presentation.png" },
  { title: "Campaign Stratargy & Excuation", img: "https://static.wixstatic.com/media/d56fdc_48522a73328f4bc69e31e11cb93ca732~mv2.png/v1/crop/x_314,y_141,w_1291,h_799/fill/w_738,h_456,fp_0.50_0.50,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/Blue%20and%20White%20Illustration%20Build%20a%20Business%20Team%20Presentation%20(1).png" },
  { title: "Influencer Marketing", img: "https://static.wixstatic.com/media/d56fdc_b0ea204de9ca457d99536d41500b31e3~mv2.png/v1/fill/w_683,h_443,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/Orange%20and%20Brown%20Illustration%20Business%20Report%20Presentation%20(13).png" },
];

const headingVariants = {
  hidden: { opacity: 0, y: 50 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.8,
      ease: "easeOut"
    }
  }
};

const cardContainerVariants = {
  hidden: { opacity: 1 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2,
      delayChildren: 0.4
    }
  }
};

const cardVariants = {
  hidden: { opacity: 0, y: 50, scale: 0.95 },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: {
      duration: 0.6,
      ease: "easeOut"
    }
  }
};

export default function MarketingSolutions() {
  const navigate = useNavigate(); // <-- Step 2

  return (
    <div className="marketing-solutions-section">
      <motion.h2
        className="marketing-solutions-heading"
        variants={headingVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.5 }}
      >
        MARKETING SOLUTIONS
      </motion.h2>

      <motion.div
        className="marketing-solutions-cards-container"
        variants={cardContainerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.3 }}
      >
        {services.map((service) => (
          <motion.div
            className="marketing-solutions-card"
            key={service.title}
            variants={cardVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.5 }}
          >
            <div className="marketing-solutions-content-left">
              <h3 className="marketing-solutions-title">{service.title}</h3>
              <motion.button
                onClick={() => navigate("/lets-connect")}
                className="marketing-solutions-btn"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                Know More
              </motion.button>
            </div>
            <div className="marketing-solutions-content-right">
              <motion.img
                src={service.img}
                alt={service.title}
                className="marketing-solutions-image"
                loading="lazy"
                draggable="false"
                whileHover={{ scale: 1.1, rotate: 5 }}
              />
            </div>
          </motion.div>
        ))}
      </motion.div>
    </div>
  );
}
